import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "./index.css";
import LoginForm from "./LoginForm";
import CreateAccount from "./CreateAccount";
import ForgotPassword from "./ForgotPassword";
import { getCurrentYear } from "../../../_utils";
import queryString from "querystring";
import { split } from "lodash";
class Login extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.showLogin !== !prevState.isUserCreatingNewAccount) {
      return { isUserCreatingNewAccount: nextProps.showLogin };
    }
  }
  state = {
    isUserCreatingNewAccount: false,
    isUserRequestingPassword: false
  };
  componentDidMount() {
    try {
      const { location } = this.props;
      let splitQueryString = split(location.search, "?");

      const values =
        splitQueryString.length === 1
          ? ""
          : queryString.parse(splitQueryString[1]);

      if (values.signup) {
        this.setState({
          isUserCreatingNewAccount: true,
          isUserRequestingPassword: false
        });
      } else if (values.forgot_password) {
        this.setState({
          isUserCreatingNewAccount: false,
          isUserRequestingPassword: true
        });
      } else {
        this.setState({
          isUserCreatingNewAccount: false,
          isUserRequestingPassword: false
        });
      }
    } catch (error) {
      //do nothing
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.location.search !== this.props.location.search) {
      try {
        const { location } = this.props;
        let splitQueryString = split(location.search, "?");

        const values =
          splitQueryString.length === 1
            ? ""
            : queryString.parse(splitQueryString[1]);

        if (values.signup) {
          this.setState({
            isUserCreatingNewAccount: true,
            isUserRequestingPassword: false
          });
        } else if (values.forgot_password) {
          this.setState({
            isUserCreatingNewAccount: false,
            isUserRequestingPassword: true
          });
        } else {
          this.setState({
            isUserCreatingNewAccount: false,
            isUserRequestingPassword: false
          });
        }
      } catch (error) {
        //do nothing
      }
      console.log(this.props.location.search);
    }
  }
  _toggleNewAccountStatus = () => {
    this.setState(prevState => ({
      isUserCreatingNewAccount: !prevState.isUserCreatingNewAccount
    }));
  };
  render() {
    const {
      username,
      password,
      isFormValid,
      isUserCreatingNewAccount,
      isUserRequestingPassword
    } = this.state;
    const { onLogin, onCreateAccount, onForgotPassword } = this.props;
    return (
      <div class="dev-page dev-page-login dev-page-login-v2">
        <div class="dev-page-login-block">
          <a class="dev-page-login-block__logo">ANUP</a>
            <LoginForm
              onLogin={onLogin}
              onCreateAccount={this._toggleNewAccountStatus}
            />
          <div class="dev-page-login-block__footer">
            © {getCurrentYear()} <strong>amst.co.in</strong>. All rights
            reserved.
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(Login);



// WEBPACK FOOTER //
// ./src/_components/UI/Login/index.js